const Header = () => {
  return (
    <header className="bg-[#3b444d] text-white shadow-xl">
      <div className="container mx-auto px-4 py-8">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <img 
              src="https://customer-assets.emergentagent.com/job_advert-food-check/artifacts/qkwu1app_IPM_logo_white%20text.png" 
              alt="IPM Logo" 
              className="h-16 w-auto object-contain"
            />
          </div>
          <div className="text-right">
            <h1 className="text-4xl font-bold mb-2" style={{ fontFamily: "'Sofia Sans', sans-serif" }}>
              Nutrient Profiling Calculator
            </h1>
            <p className="text-gray-300 text-lg">
              UK Advertising Compliance Tool
            </p>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
